/** Whole calendar days from today (local) until the trial end date (local). */
export function trialRemainingDays(endsAt?: string | Date): number | null {
  if (!endsAt) {
    return null;
  }
  const parsed = typeof endsAt === 'string' ? new Date(endsAt) : endsAt;
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }
  const endDay = new Date(parsed);
  endDay.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.max(0, Math.round((endDay.getTime() - today.getTime()) / 86400000));
}
